export default __webpack_public_path__ + "static/media/advantagefocusedfire.15398846.png";